import MuiListItemIcon, { ListItemIconProps } from '@mui/material/ListItemIcon';
import clsx from 'clsx';

const EDListItemIcon = (props: ListItemIconProps) => {
  return (
    <MuiListItemIcon
      {...props}
      sx={{
        '&.minWidth': {
          minWidth: theme => theme.spacing(5),
        },
      }}
      className={clsx('minWidth', props.className)}
    />
  );
};

export default EDListItemIcon;
